export default __webpack_public_path__ + "static/media/amex1.63b99ca3.svg";